/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

import { Title } from './Text'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'

const MobilePageHeader = ({ title, rightContent, leftContent, footer }) => {
  const style = css`
    position: relative;
    background: white;
    box-shadow: ${COLORS.lightShadow1};

    & > .content {
      padding: 1rem;
    }
  `

  return (
    <div className="mPageHeader" css={style}>
      <div className="content">
        <FlexGrid justify="space-between">
          <FlexCol flex={1}>{leftContent}</FlexCol>
          <FlexCol flex={4}>
            <Title size="h5" align="center" noMargin>
              {title}
            </Title>
          </FlexCol>
          <FlexCol flex={1}>{rightContent}</FlexCol>
        </FlexGrid>
      </div>
      {footer}
    </div>
  )
}

export default MobilePageHeader
